module.exports = __webpack_public_path__ + "static/media/union3.f10bf585.png";